import { Component, Injector, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { SettingService } from './system-common/services/setting.service';
//import { OfflineService } from './offline/offline.service';
@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.css'],
})
export class AppComponent implements OnInit {
  constructor(
    private settingService: SettingService,
    //private offlineService: OfflineService,
    private router: Router,
    private injector: Injector
  ) {
    SettingService.setInjector(injector);
    if (this.settingService.getApplicationMode() === 'offline' && this.settingService.isRhosimulator !== true) {
      // this.offlineService.showSplashScreen();
      // this.offlineService.initializeApp();
    } else {
      if (
        this.settingService.getSessionStorageValue('USER') == undefined ||
        this.settingService.getSessionStorageValue('USER') == ''
      ) {
        //this line is not required since it anyways navigates to login page
        //this.router.navigate(['login']);
      }
    }
  }

  ngOnInit() {}
  initializeApp() {}
}
